import { Stack } from "@mui/material";
import React from "react";
import { FeedbackInsightsLogo } from "../../../assets/Feedback-Insights";
import {
  useFoundationColorTokens,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { VIEWPORT } from "@pulse/shared-components";
import { observer } from "mobx-react";
import { EmailCampaignOptOutPageContent } from "./content/EmailCampaignOptOutPageContent";

const FEEDBACK_INSIGHTS_LOGO_WIDTH = "102px";
const FEEDBACK_INSIGHTS_LOGO_HEIGHT = "48px";

export const EmailCampaignOptOutPage: React.FC = observer(() => {
  const spacing = useSpacing();
  const tokens = useFoundationColorTokens();

  return (
    <Stack
      paddingBlock={spacing.spaceMD}
      paddingInline={spacing.space2XL}
      height={VIEWPORT.MAX_HEIGHT}
      width={VIEWPORT.MAX_WIDTH}
      bgcolor={tokens.backgroundPrimarySubtle}
    >
      <Stack>
        <FeedbackInsightsLogo
          width={FEEDBACK_INSIGHTS_LOGO_WIDTH}
          height={FEEDBACK_INSIGHTS_LOGO_HEIGHT}
        />
      </Stack>
      <EmailCampaignOptOutPageContent />
    </Stack>
  );
});
